/*
 * @Description: 
 */

// let baseUrl = "http://localhost:8081/jz";
// let whUrl = "http://localhost:8081/wh";

let baseUrl = process.env.VUE_APP_API+'/jz'
let whUrl = process.env.VUE_APP_API+'/wh'


const API = {
	// 后门登录
	login: baseUrl + "/a/login",

    // bluewhale接口（微服务）
    smsCodeForRegist : whUrl + '/front/SMS/sendSMSCode/',//用户注册发送短信验证码
    userRegist : whUrl + '/front/user/userRegister',//用户注册
    smsCodeForFindpassword : whUrl + '/front/SMS/updatePasswordBySMSCode/',//找回密码发送短信验证码
    resetPassword : whUrl + '/front/user/updatePassword/',//用户重设密码
    userWhInfo:whUrl + '/front/user/getUserInfo',
    getPersonCos:whUrl + '/front/cos/getCredential',//个人中心cos初始化桶信息
    updatePassword:whUrl + '/front/user/updatePasswordByOldPassword/',
    getUserData: whUrl + '/front/user/getUserInfo',
    sendCodeByMobile: whUrl + '/front/SMS/userLoginBySMSCode',
    
    
    userLogin : baseUrl +'/front/user/userLogin',//用户密码登录
    userLoginByMobile:baseUrl + '/front/user/userLoginByMobile',
    userLogout : baseUrl + '/front/user/userLogout',//用户登出
    userInfo: baseUrl + '/userToRole/getUserInfo',
    updateUserInfo:baseUrl + '/front/user/userCenterUpdateInfo', //修改用户信息


	getIndexCategry: baseUrl + "/profession/front/topList",//首页九个专业和对应十个构件
    getIndexCompany: baseUrl + '/company/front/getLastAddList', //首页展示最新入驻的十家企业
    getCateNumber:baseUrl + '/componentLibrary/front/getCount',

	downLoadApp: baseUrl + "/revitVersion/front/download",//下载

    revitVersion:baseUrl + '/revitVersion/list',//revit版本
    categoryList: baseUrl + '/profession/list', //分类列表
    companyBrandList:baseUrl + '/companyBrand/list',//品牌列表
    getFamilyList : baseUrl + '/componentLibrary/front/getList',//构件列表（含多条件搜索）

    getCompanyList:baseUrl + '/company/getCompanyList', //厂家列表
    getCompanyDetailById: baseUrl + '/company/get',

    addApply:baseUrl + '/companyEntryApply/front/add', //添加厂家申请

    userCollect: baseUrl + '/userCollectLog/add', //收藏构件
    cancelCollect:baseUrl + '/userCollectLog/cancel', //取消收藏
    userCollectList: baseUrl + '/userCollectLog/list',
    userDown:baseUrl + '/componentLibrary/downComponentLibrary', //下载构件
    delCollect: baseUrl + '/userCollectLog/delBatch',
    userShare:baseUrl + '/userShareLog/add',
    getCompoentRevit:baseUrl + '/componentLibrary/getVersionList',
    getDownNum:baseUrl + '/componentLibrary/front/getDownNum',

    // 构件
    myComponentsList: baseUrl + '/componentLibrary/getComponentListByUser',//我的构件列表
    myCollectList: baseUrl + '/userCollectLog/getUserCollectLogPage',//我的收藏列表
    componentDetail: baseUrl +'/componentLibrary/info',//构件详情根据id查询
    delComponents:baseUrl+'/componentLibrary/remove',//批量删除构件
    myDownloadComponentsList: baseUrl +'/usageLog/getUserDownloadPage',//我的下载列表
    delDownload: baseUrl + '/usageLog/remove',//





};

export default API;
